/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import {accountsGet} from "../fn/account/accounts-get";
import {AccountModel} from "../models/account-model";
import {AccountPostParams, accountsPost} from "../fn/account/account-post";
import {accountDetailsGet, AccountDetailsGetParams} from "../fn/account/account-details-get";
import {accountUsersPost, AccountUsersPostParams} from "../fn/account/account-users-post";
import {UserDetailsModel} from "../models/user-details-model";
import {accountQuestionnairesGet, AccountQuestionnairesGetParams} from "../fn/account/account-questionnaires-get";
import {QuestionnaireModel} from "../models/questionnaire-model";
import {AccountExistingUserPostParams, existingUserAccountPost} from "../fn/account/account-existing-user-post";
import {EmailAddressAvailableParams, emailAddressAvailablePost} from "../fn/account/email-address-available-post";
import {accountDelete, AccountDeleteParams} from "../fn/account/account-delete";

@Injectable({ providedIn: 'root' })
export class AccountService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /** Path part for operation `authenticatePost()` */
    static readonly accountsGetPath = '/api/v1/identity/authenticate';
    static readonly accountDeletePath = '/api/v1/accounts/{accountGuid}';

    /**
     * Gets all accounts that the user has access to
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `accountsGet()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    accountsGet$Response(headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<AccountModel[]>> {
        return accountsGet(this.http, this.rootUrl, headers, context);
    }

    /**
     * Gets all accounts that the user has access to
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `accountsGet$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    accountsGet(headers: HttpHeaders, context?: HttpContext): Observable<AccountModel[]> {
        return this.accountsGet$Response(headers, context).pipe(
            map((r: StrictHttpResponse<AccountModel[]>): AccountModel[] => r.body)
        );
    }

    /**
     * Gets the details for a particular account
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `accountDetailsGet()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    accountDetailsGet$Response(params: AccountDetailsGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<AccountModel>> {
        return accountDetailsGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets all questionnaires related to an account
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `accountQuestionnairesGet$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    accountQuestionnairesGet(params: AccountQuestionnairesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<QuestionnaireModel[]> {
        return this.accountQuestionnairesGet$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<QuestionnaireModel[]>): QuestionnaireModel[] => r.body)
        );
    }

    /**
     * Gets all questionnaires related to an account
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `accountQuestionnairesGet()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    accountQuestionnairesGet$Response(params: AccountQuestionnairesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireModel[]>> {
        return accountQuestionnairesGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets the details for a particular account
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `accountDetailsGet$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    accountDetailsGet(params: AccountDetailsGetParams, headers: HttpHeaders, context?: HttpContext): Observable<AccountModel> {
        return this.accountDetailsGet$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<AccountModel>): AccountModel => r.body)
        );
    }

    /**
     * Creates a new account
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `accountPost()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    newUserAccountPost$Response(params: AccountPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<AccountModel>> {
        return accountsPost(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Creates a new account
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `accountPost$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    newUserAccountPost(params: AccountPostParams, headers: HttpHeaders, context?: HttpContext): Observable<AccountModel> {
        return this.newUserAccountPost$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<AccountModel>): AccountModel => r.body)
        );
    }

    /**
     * Creates a new account
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `existingUserAccountPost()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    existingUserAccountPost$Response(params: AccountExistingUserPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<AccountModel>> {
        return existingUserAccountPost(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Creates a new account
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `existingUserAccountPost$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    existingUserAccountPost(params: AccountExistingUserPostParams, headers: HttpHeaders, context?: HttpContext): Observable<AccountModel> {
        return this.existingUserAccountPost$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<AccountModel>): AccountModel => r.body)
        );
    }

    /**
     * Creates a new user and associates them with an account. If user with email already exists, it updates that
     * users account membership to be included in
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `accountUsersPost()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    accountUsersPost$Response(params: AccountUsersPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<UserDetailsModel>> {
        return accountUsersPost(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Creates a new user and associates them with an account. If user with email already exists, it updates that
     * users account membership to be included in
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `accountUsersPost$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    accountUsersPost(params: AccountUsersPostParams, headers: HttpHeaders, context?: HttpContext): Observable<UserDetailsModel> {
        return this.accountUsersPost$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<UserDetailsModel>): UserDetailsModel => r.body)
        );
    }

    /**
     * Determines whether an email address is available
     *
     *
     *
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    emailAddressAvailablePost$Response(params: EmailAddressAvailableParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<string>> {
        return emailAddressAvailablePost(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Deactivates an account after confirming the current user's password.
     */
    accountDelete$Response(params: AccountDeleteParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return accountDelete(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Deactivates an account after confirming the current user's password.
     */
    accountDelete(params: AccountDeleteParams, headers: HttpHeaders, context?: HttpContext): Observable<void> {
        return this.accountDelete$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<void>): void => r.body)
        );
    }
}
